<template>
  <!-- 表格数据 -->
  <el-table
    v-loading="loading"
    :data="listData"
  >
    <el-table-column
      prop="order_id"
      label="订单号"
      width="155px"
    />

    <el-table-column label="销售员工姓名">
      <template slot-scope="scope">
        <span v-if="scope.row.sale_salesperson">{{
          scope.row.sale_salesperson.salesperson_name
        }}</span>
        <span v-else>--</span>
      </template>
    </el-table-column>
    <el-table-column label="销售导购工号">
      <template slot-scope="scope">
        <span v-if="scope.row.sale_salesperson">{{
          scope.row.sale_salesperson.employee_number
        }}</span>
        <span v-else>--</span>
      </template>
    </el-table-column>

    <el-table-column label="销售门店">
      <template slot-scope="scope">
        <div>{{ scope.row.sale_store.store_name }}</div>
        <div>{{ scope.row.sale_store.store_bn }}</div>
      </template>
    </el-table-column>

    <el-table-column label="绑定员工姓名">
      <template slot-scope="scope">
        <span v-if="scope.row.bind_salesperson">{{
          scope.row.bind_salesperson.salesperson_name
        }}</span>
        <span v-else>--</span>
      </template>
    </el-table-column>
    <el-table-column label="绑定导购工号">
      <template slot-scope="scope">
        <span v-if="scope.row.bind_salesperson">{{
          scope.row.bind_salesperson.employee_number
        }}</span>
        <span v-else>--</span>
      </template>
    </el-table-column>
    <el-table-column label="绑定门店">
      <template slot-scope="scope">
        <div>{{ scope.row.bind_store.store_name }}</div>
        <div>{{ scope.row.bind_store.store_bn }}</div>
      </template>
    </el-table-column>

    <el-table-column
      prop="total_fee"
      label="订单实付金额"
    >
      <template slot-scope="scope">
        <span>¥</span>
        <span>{{ Number(scope.row.total_sales_fee) / 100 }}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="order_status_msg"
      label="订单状态"
    />
    <el-table-column
      prop="order_create_time"
      label="创建时间"
    />
  </el-table>
</template>

<script>
export default {
  props: {
    listData: {
      type: Array
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      key: []
    }
  }
}
</script>

<style lang="scss" scoped></style>
